<template >
    <v-col cols="12 pa-0 pb-3" :id="'question-id-'+question.questionId" >
        <v-row no-gutters class="mb-4" v-if="question.answerType === 'Title'">
            <v-col cols="12"><span class="title black--text" style="text-decoration: underline;">{{question.question}}</span></v-col>
        </v-row>
        <v-row no-gutters class="mb-4" v-else-if="question.answerType === 'DescriptionText'">
            <v-col cols="12" class="text-justify"><span class="title black--text" style="font-weight: normal;">{{question.question}}</span></v-col>
        </v-row>
        <v-row no-gutters  v-else-if="question.answerType === 'Image'">
            <v-col cols="12" style="max-width: fit-content !important;">
                <v-img
                        :src="baseUrl+'/'+question.imagePath"
                        contain
                >
                </v-img>
            </v-col>
        </v-row>
        <v-card v-else>
            <!--            <v-card :id=" 'question_' + index">-->
            <v-card-text>
                <div>

                    <v-row no-gutters>
                        <v-col cols="1 pt-1"><span v-show="question.isImportant" style="color:red;">*</span><span>{{question.qNo+1}}</span></v-col>
                        <v-col cols="11"><span class="title">{{question.question}}</span></v-col>
                    </v-row>
                </div>
                <v-layout v-if="question.answerType === 'Textbox'" column mr-3 :id="'type_text_box_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-text-field
                                :value="response['question_'+question.answerType+'_'+question.questionId]" @change="v => {response['question_'+question.answerType+'_'+question.questionId] = v; resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId);}"
                                clearable
                                :key = "question.questionId"
                                :id="'type_text_box_input_'+index+1"
                                @keyup="validateMandatoryForTextField('type_text_box_input_'+index+1, question)"
                                @click:clear="validateMandatoryForTextField('type_text_box_input_'+index+1, question, 'clear')"
                        ></v-text-field>
                        <!--                                    label="<g:message code='enter.the.value'/>"-->
                        <!--                                        @keyup="resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId)"-->
                    </v-col>
                </v-layout>
                <v-layout v-if="question.answerType === 'DigitBox'" column mr-3 :id="'type_digit_box_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-text-field
                                type="number"
                                :value="response['question_'+question.answerType+'_'+question.questionId]" @change="v =>{ response['question_'+question.answerType+'_'+question.questionId] = v; resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId);}"
                                clearable
                                :key = "question.questionId"
                                :id="'type_text_box_input_'+index+1"
                                @keyup="validateMandatoryForTextField('type_text_box_input_'+index+1, question)"
                                @click:clear="validateMandatoryForTextField('type_text_box_input_'+index+1, question,'clear')"
                        ></v-text-field>
                        <!--                                    label="<g:message code='enter.the.value'/>"-->
                        <!--                                        @keyup="resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId)"-->
                    </v-col>
                </v-layout>
                <v-layout v-if="question.answerType === 'ListInput'" column mr-3 :id="'type_list_input_'+index">
                    <v-flex xs12 sm6>
                        <v-text-field
                                v-model="response['question_'+question.answerType+'_'+question.questionId]"
                                clearable
                                :key = "question.questionId"
                                @keyup="validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question);resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId)"
                        ></v-text-field>
                        <!--                                    label="<g:message code='enter.the.list'/>"-->
                    </v-flex>
                </v-layout>
                <v-layout v-if="question.answerType === 'MultipleChoice'" column wrap mr-4 ma-2 :id="'type_multiple_choice_'+index">
                    <v-item-group column multiple>
                        <v-checkbox  v-for="(choice) in question.choices"
                                     :value="response['question_'+question.answerType+'_'+question.questionId+'_'+choice.choiceId]"
                                     :class="choice.hasTextField?'multiple-choice-input align-bottom mt-0 pt-0':'ma-0'"
                                     :key="choice.choiceId"
                                     @change="(v) => { response['question_'+question.answerType+'_'+question.questionId+ '_'+choice.choiceId] = v?choice:''; validateMandatory(v, question); checkDependencyForMultipleChoice(question, v , choice);}"
                                     :ripple="false"
                        >

                            <template slot="label" >
                                <!--                                            <span class="hidden">{{response['question_'+question.answerType+'_'+question.questionId+'_'+choice.choiceId] }}</span>-->
                                <span style="display: flex; text-align: start;"> {{choice.choice}} &nbsp; &nbsp; &nbsp;<v-text-field height='20' class="pt-0 mt-0 mr-2 choice-input-box" v-if="choice.hasTextField" :value="response['question_'+question.answerType+'_'+question.questionId + '_' + choice.choiceId + '_input']" @click.stop="" @change="v => {response['question_'+question.answerType+'_'+question.questionId+'_'+choice.choiceId] = choice; response['question_'+question.answerType+'_'+question.questionId + '_'+choice.choiceId+'_input'] = v}" clearable />
                                </span>
                            </template>
                        </v-checkbox>
                    </v-item-group>
                </v-layout>
                <v-layout v-if="question.answerType === 'RadioList'"  column mb-3 wrap mr-0 :id="'type_radio_list_'+index">
                    <v-radio-group :value="response['question_'+question.answerType+'_'+question.questionId]" column>
                        <v-radio v-for="(choice, ix) in question.choices"
                                 :value="choice"
                                 :class="choice.hasTextField?'radio-choice-input':''"
                                 :key="choice.choiceId"
                                 @change="(v) => {scrollSurvey(index, choice);  response['question_'+question.answerType+'_'+question.questionId] = choice; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); checkDependencyAndResetImportantFlag(question,choice);}"
                                 style = "height:auto;"
                                 :ripple="false"
                        >
                            <template slot="label">
                                <span style="display: flex; text-align: start;"> {{choice.choice}} &nbsp; &nbsp; &nbsp;<v-text-field class="mt-0 pt-0 mr-2" height="20" v-if="choice.hasTextField" :value="response['question_'+question.answerType+'_'+question.questionId + '_' + choice.choiceId + '_input']" @click.stop="" @change="v => response['question_'+question.answerType+'_'+question.questionId + '_'+choice.choiceId+'_input'] = v" clearable/>
                                </span>
                            </template>
                        </v-radio>
                    </v-radio-group>

                    <!--                    <div  v-for="(choice, ix) in question.choices" :key="choice.choiceId" class="d-flex mb-3 mr-3">-->
                    <!--                             <input type="radio" :id="choice.choiceId" :value="choice" :name="'question_'+question.answerType+'_'+question.questionId"-->
                    <!--                                    @change="(v) => {scrollSurvey(index); checkDependencyAndResetImportantFlag(question,choice); response['question_'+question.answerType+'_'+question.questionId] = choice}"-->
                    <!--                             >-->
                    <!--                            <label :for="choice.choiceId" class="mr-3">{{choice.choice}}</label>-->
                    <!--                                <v-text-field class="mt-0 pt-0 mr-2" height="20" v-if="choice.hasTextField" :value="response['question_'+question.answerType+'_'+question.questionId + '_' + choice.choiceId + '_input']" @click.stop="" @change="v => response['question_'+question.answerType+'_'+question.questionId + '_'+choice.choiceId+'_input'] = v" clearable/>-->
                    <!--                    </div>-->
                </v-layout>
                <v-layout v-if="question.answerType === 'DropdownCustom'" column mr-2 :id="'type_drop_down_custom_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-combobox
                                :value="response['question_'+question.answerType+'_'+question.questionId]"
                                :items="question.choices"
                                :search-input.sync="dropdown_search"
                                item-text="choice"
                                hide-selected
                                :key = "question.questionId"
                                type="button"
                                persistent-hint
                                small-chips
                                @change = "(v) =>{ response['question_'+question.answerType+'_'+question.questionId] = v; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); checkDependencyAndResetImportantFlag(question,v);}"
                        ></v-combobox>
                    </v-col>
                </v-layout>
                <v-layout v-if="question.answerType === 'YesNoType'" column :id="'type_yes_no_'+index">
                    <v-radio-group class="mr-2" :value="response['question_'+question.answerType+'_'+question.questionId]" column>
                        <v-radio v-for="(choice) in question.choices"
                                 :label="choice.choice"
                                 :key="choice.choiceId"
                                 :value="choice"
                                 ms-0
                                 @change="(v) => { response['question_'+question.answerType+'_'+question.questionId] = choice; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); checkDependencyAndResetImportantFlag(question,choice);}"
                                 :ripple="false"
                        >
                            <!--                                             :label="$t('message.'+choice.choice+'')"-->
                        </v-radio>
                    </v-radio-group>
                </v-layout>
                <v-layout v-if="question.answerType === 'NoYesType'" column :id="'type_no_yes_'+index">
                    <v-radio-group class="mr-2" :value="response['question_'+question.answerType+'_'+question.questionId]" column>
                        <v-radio v-for="(choice) in question.choices"
                                 :label="choice.choice"
                                 :key="choice.choiceId"
                                 :value="choice"
                                 ms-0
                                 @change="(v) => { response['question_'+question.answerType+'_'+question.questionId] = choice; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); checkDependencyAndResetImportantFlag(question,choice);}"
                                 :ripple="false"
                        >
                            <!--                                             :label="$t('message.'+choice.choice+'')"-->
                        </v-radio>
                    </v-radio-group>
                </v-layout>
                <v-layout v-if="question.answerType === 'DropdownPredefined'" column :id="'type_drop_down_predefined_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-combobox
                                :value="response['question_'+question.answerType+'_'+question.questionId]"
                                :items="question.choices"
                                :search-input.sync="dropdown_search"
                                hide-selected
                                type="button"
                                :key = "question.questionId"
                                persistent-hint
                                small-chips
                                @change = "(v) => {response['question_'+question.answerType+'_'+question.questionId] = v; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); checkDependencyAndResetImportantFlag(question,v);} "
                        ></v-combobox>
                    </v-col>
                </v-layout>
                <v-layout v-if="question.answerType === 'Date'" row mr-2 :id="'type_date_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-menu
                                :ref="'menu_'+question.questionId"
                                v-model="dateQuestions['vuePreviewSurveyDataframe_menu_'+question.questionId]"
                                :close-on-content-click="false"
                                :return-value.sync="dateQuestions['question_date_'+question.questionId]"
                                transition="scale-transition"
                                offset-y
                                min-width="200px"
                                style="width:auto; height:auto;"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="dateQuestions['question_date_formated_'+question.questionId]"
                                        v-on="on"
                                        persistent-hint
                                        prepend-icon="event"
                                        @click:prepend="onIconClick_vuePreviewSurveyDataframe_date(question.questionId)"
                                        readonly
                                ></v-text-field>
                            </template>
                            <v-date-picker locale='he' v-model="dateQuestions['question_date_'+question.questionId]"  no-title @input="$refs['menu_'+question.questionId].save(vuePreviewSurveyDataframe_date_formatted(dateQuestions['question_date_'+question.questionId], question.questionId)); validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId);"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-layout>

                <v-layout v-if="question.answerType === 'City'" row mr-3 :id="'type_city_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-combobox
                                :value="response['question_'+question.answerType+'_'+question.questionId]"
                                :items="cityAndStreetItems"
                                item-text="choice"
                                small-chips
                                hide-selected
                                :key = "question.questionId"
                                :label="$t('city')"
                                @change = "(v) => {response['question_'+question.answerType+'_'+question.questionId] = v; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question); resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId);} "
                                persistent-hint
                        ></v-combobox>
                    </v-col>
                </v-layout>

                <v-layout v-if="question.answerType === 'CityStreet'" row mr-3 :id="'type_city_street_'+index">
                    <v-col cols="pt-0" sm="8">
                        <v-combobox
                                :value="response['question_'+question.answerType+'_'+question.questionId]"
                                :items="cityAndStreetItems"
                                item-text="choice"
                                small-chips
                                hide-selected
                                :key = "question.questionId"
                                :label="$t('city')"
                                @change = "(v) => {selectStreet(index, question, v);response['question_'+question.answerType+'_'+question.questionId] = {'choice':v.choice, 'code':v.code}; response['question_'+question.answerType+'_'+question.questionId+'_street'] = {}; validateMandatory(response['question_' + question.answerType + '_' + question.questionId], question);}"
                                persistent-hint
                        ></v-combobox>
                        <v-combobox v-show="showHideStreet['vuePreviewSurveyDataframe_street_'+question.questionId]"
                                    :value="response['question_'+question.answerType+'_'+question.questionId+'_street']"
                                    :items="question_choices_street_items[index]"
                                    item-text="choice"
                                    :small-chips = "smallChips"
                                    hide-selected
                                    @change = "(v) => {response['question_'+question.answerType+'_'+question.questionId+ '_street'] = v; selectedStreet = v;}"
                                    :label="$t('street')"
                                    persistent-hint
                        ></v-combobox>
                        <v-text-field v-show="showHideStreet['vuePreviewSurveyDataframe_street_'+question.questionId]"
                                      :value="response['question_'+question.answerType+'_'+question.questionId+'_neighbourhood']" @change="v => response['question_'+question.answerType+'_'+question.questionId + '_neighbourhood'] = v"
                                      :label="$t('neighbourhood')"
                        ></v-text-field>
                        <v-text-field v-show="showHideStreet['vuePreviewSurveyDataframe_street_'+question.questionId]"
                                      :value="response['question_'+question.answerType+'_'+question.questionId+'_houseNumber']" @change="v => response['question_'+question.answerType+'_'+question.questionId + '_houseNumber'] = v"
                                      :label="$t('houseNumber')"
                        ></v-text-field>
                    </v-col>
                </v-layout>
                <span v-if="question.showMandatoryMessage" style="color:red;">{{this.$t("mandatory_question_error_message")}}</span>
            </v-card-text>
        </v-card>
    </v-col>
</template>
<script>
import config from "../ayalconfig";
import cityAndStreet from "../resources/cityStreet"
import {mapGetters, mapMutations} from "vuex";
import {isEmpty} from "../service/service";

export default {
    data() {
        return {
            survey: {},
            dropdown_search: '',
            showImportantQuestionMessage: false,
            vuePreviewSurveyDataframe_date: [],
            vuePreviewSurveyDataframe_street_select: [],
            question_choices_street_items: [],
            importantQuestions: [],
            dateQuestions: {},
            questionIdsList: [],
            cityAndStreetItems: cityAndStreet.cityAndStreet,
            scroll: {duration:200 , offset:0 , easing:'linear'},
            selectedStreet:{},
            smallChips:false
        };
    },
    props:["question", "index"],
    watch:{
        selectedStreet: function (val){
            if(val && val.code){
                this.smallChips = true
            }else{
                this.response['question_'+this.question.answerType+'_'+this.question.questionId+'_street'] = ''
                this.smallChips = false
            }
        }
    },
    computed: {

        ...mapGetters(["_questionaire", "showHideStreet", "dependentQuestions"]),
        response() {
            return this.$store.state.survey;
        },
        dependentQuestion() {
            return this.$store.state.dependentQuestions
        },
        scroll_options() {
            return {
                duration: this.scroll.duration,
                offset: this.scroll.offset,
                easing: this.scroll.easing,
            }
        },
        baseUrl(){
            return config.baseUrl()
        }
    },
    methods: {
        ...mapMutations({resetDependencyInState:"resetDependency", insertToQuestionaire:"insertToQuestionaire", setShowHideStreet:"showHideStreet"}),

        validateMandatory(modelString, question) {
            if (!modelString && question.importanceLevel === "Mandatory") {
                question.showMandatoryMessage = true;
            }
            else if(modelString) {
                question.showMandatoryMessage = false;
            }
        },
        validateMandatoryForTextField(inputId, question, event){
            let inputValue = document.getElementById(inputId).value
            if((event ==="clear" || !inputValue) &&  question.importanceLevel === "Mandatory") {
                question.showMandatoryMessage = true;
            }
            else if(inputValue){
                question.showMandatoryMessage = false
            }

        },
        checkDependencyAndResetImportantFlag(question, choice){
            this.checkDependency(question, choice);
            this.resetImportantFlag(question, 'question_'+question.answerType+'_'+question.questionId);
            if(choice && choice.questionToJump){
                this.jumpToSpecificQuestion(choice.questionToJump)
            }

        },
        checkDependency(question,currentChoice){
            if(!currentChoice){
                return
            }
            new Dependency(this, question, currentChoice).show();

            function Dependency(self, currentQuestion, currentChoice){
                this.currentQuestion = currentQuestion;
                this.currentChoice = currentChoice;

                let dependencyQuestionsMap = self.dependentQuestion;
                let setDependenciesMap = {};
                Dependency.prototype.show = () => {
                    let allChoicesOfCurrentQuestion = this.currentQuestion.choices;
                    for(let ch in allChoicesOfCurrentQuestion) {
                        manageDependentQuestions(allChoicesOfCurrentQuestion[ch]);
                    }
                }
                const manageDependentQuestions = (choice) => {
                    if(!choice){
                        return
                    }
                    if (isCurrentChoice(choice)) {
                        showDependentQuestions(this.currentChoice);
                    } else {
                        hideDependentQuestions(choice);
                    }

                    self.resetDependencyInState(dependencyQuestionsMap);
                }
                const isCurrentChoice = (choice) =>{
                    return choice.choiceId === this.currentChoice.choiceId;
                }
                const showDependentQuestions = (choice) =>{
                    showQuestion(true, choice);
                }
                const hideDependentQuestions = (choice) => {
                    showQuestion(false, choice)
                }

                function showQuestion(show = true, choice){
                    let dependentQuestions = choice.dependentQuestions;
                    for (let ds of dependentQuestions) {
                        let showVar = "show_" + ds;
                        if(setDependenciesMap.hasOwnProperty(ds)){
                            return
                        }
                        if(show){
                            setDependenciesMap[ds] = true;
                        }
                        if (config.dependency.showByDefault) {
                            dependencyQuestionsMap[showVar] = !show;
                        } else {
                            dependencyQuestionsMap[showVar] = show;
                        }
                    }
                }

            }
        },
        jumpToSpecificQuestion(questionToJump){
            this.$nextTick(()=> window.document.getElementById("question-id-"+questionToJump.questionToJump.id).scrollIntoView({behavior: "smooth", block: "start", inline: "center"}));
        },

        checkDependencyForMultipleChoice(question, selected, choice){
            let depQuestions = choice.dependentQuestions;
            let depQsList = this.dependentQuestion;
            for(let ds of depQuestions){
                let showVar = "show_" + ds;
                if(selected){
                    if (config.dependency.showByDefault) {
                        depQsList[showVar] = false;
                    } else {
                        depQsList[showVar] = true;
                    }
                } else {
                    if (config.dependency.showByDefault) {
                        depQsList[showVar] = true;
                    } else {
                        depQsList[showVar] = false;
                    }
                }
                this.resetDependencyInState(depQsList);
            }
            this.resetImportantFlag(question, 'question_'+'MultipleChoice_'+question.questionId+"_"+choice.choiceId);
            if(selected && choice.questionToJump){
                this.jumpToSpecificQuestion(choice.questionToJump)
            }
        },
        selectStreet(index, question, e){
            this.selectedStreet = {'choice':'', 'code':''};
            let streetItems = e.streets;
            let questionId = question.questionId;
            this.question_choices_street_items[index] = streetItems;
            this.vuePreviewSurveyDataframe_street = true;
            this.vuePreviewSurveyDataframe_street_select[index] = null;
            let stM = {};
            stM['vuePreviewSurveyDataframe_street_'+questionId] = true;
            this.setShowHideStreet({key:'vuePreviewSurveyDataframe_street_'+questionId, value:true});
            this.survey = stM;
            this.resetImportantFlag(question, 'question_'+question.answerType+'_'+questionId)
        },
        resetImportantFlag(question, model){
            let self = this;
            setTimeout(function(){
                try {
                    let isImportant = question.isImportant;
                    let key = question.questionId;
                    let importantQuestions = self._questionaire.importantQuestions;
                    if(isImportant){
                        let value = self.response[model];
                        let multipleChoiceSelector = 'multipleChoice';
                        let unSelectedChoices = 0;
                        if(value){
                            if (question.answerType === 'MultipleChoice'){
                                unSelectedChoices = importantQuestions[multipleChoiceSelector][key];
                                importantQuestions[multipleChoiceSelector][key] = unSelectedChoices - 1;
                            }
                            delete importantQuestions[key]
                        } else {
                            if (question.answerType === 'MultipleChoice'){
                                unSelectedChoices = importantQuestions[multipleChoiceSelector][key];
                                if (unSelectedChoices === question.choices.length - 1)
                                    importantQuestions[key] = true;
                                importantQuestions[multipleChoiceSelector][key] = unSelectedChoices + 1;
                            }else {
                                importantQuestions[key] = true;
                            }
                        }
                    }
                    if (!isEmpty(self.response)){
                        self._questionaire.showImportantQuestionMessage = Object.keys(importantQuestions).length > 1;
                    }
                }catch (e) {
                    console.log("Error showing warning message for important type response.")
                }
            }, 0);
        },
        vuePreviewSurveyDataframe_date_formatted(e, qId) {
            if (!e) return null;
            var d = new Date(e);
            this.response['question_Date_'+qId] = d;
            this.dateQuestions['question_date_formated_'+qId] = d.toISOString().split("T")[0].split('-').reverse().join('/');
        },
        onIconClick_vuePreviewSurveyDataframe_date:function(qId){
            this.dateQuestions['vuePreviewSurveyDataframe_menu_'+qId] = true;
            var dateQuestionsMap = this.dateQuestions;
            // for (var i in this.dateQuestions)
            //     dateQuestionsMap[i] = this.dateQuestions[i];
            this.dateQuestions = {};
            this.dateQuestions = dateQuestionsMap;
        },
        scrollSurvey: function(qIx, choice){
            if(!choice.questionToJump) {
                let ix = Number(qIx) + 1;
                let id = '#question_' + ix;
                const questionsSize = this._questionaire.questionIdsList.length - 1;
                // dependentQuestions['show_'+question.questionId]
                if (questionsSize && (qIx < questionsSize)) {
                    var x = document.getElementById("question_" + ix);
                    console.log(window.getComputedStyle(x).display);
                    console.log(window.getComputedStyle(x).visibility);
                    if (window.getComputedStyle(x).display === "none") {
                        // this.$vuetify.goTo(ix + 50, this.scroll_options);
                        return
                    }
                    this.$vuetify.goTo(id, this.scroll_options);
                }
            }
        },
        async handleScroll(){
            try {
                let activeElement = document.activeElement;
                if(activeElement && activeElement.tagName.toLowerCase() === 'input'){
                    setTimeout(function () {
                        let position = activeElement.getBoundingClientRect();
                        if(!(position.top >= 0 && position.bottom <= window.innerHeight)) {
                            activeElement.blur();
                        }
                    },100);
                }
            }catch (e) {

            }
        },
    }
}
</script>
<style scoped>
input[type="radio"] {
    /* width:35px;*/
    vertical-align: middle;
    /*-ms-transform: scale(1.5); !* IE 9 *!*/
    /*-webkit-transform: scale(1.5); !* Chrome, Safari, Opera *!*/
    /*transform: scale(1.5);*/
}
</style>
